import React from 'react'
import { Icon } from 'lib/ui'
import type { IconName, IconProps } from 'lib/ui'

const icons: Record<number, IconName> = {
  1: 'food',
  2: 'car',
  3: 'medkit',
  4: 'cart',
}

const CategoryIcon = ({
  category,
  ...rest
}: {
  category: number | string
} & Omit<IconProps, 'name'>) => (
  <Icon name={icons[Number(category)] ?? 'question'} {...rest} />
)

export default CategoryIcon
